import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel, useRouteData, useStateManager } from "@bcm-dev/bcms-vite";
import { ConfirmBannerView, PageContainer, PageContentView } from "components/shared";
import Classes, { ACHBatch } from "model";
import React, { useEffect } from "react";
import { SVGAsset } from "res";
import ACHBatchConfirmationWidget from "./components/ACHBatchConfirmationWidget";
import HistoryACHWidget from "./components/HistoryACHWidget";
import PendingACHBatchesWidget from "./components/PendingACHBatchesWidget";
import PendingSameDayACHBatchesWidget from "./components/PendingSameDayACHBatchesWidget ";
import ScheduledACHBatchesWidget from "./components/ScheduledACHBatchesWidget";
import "./styles.css";
import "./mobile.css";


/**
 * @function ActivityACHPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ActivityACHPage
 */
export default function ActivityACHPage(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);
  window.history.replaceState({}, document.title);
    // Branding options needed for captures
    const branding = useModel().branding.options;
    window.BRANDING = { 
        "ach_abi22" : branding.ach_abi22, 
        "users_abi22" : branding.users_abi22,
        "import_file_flyout_abi22": branding.import_file_flyout_abi22,
        "ach_import_abi22": branding.ach_import_abi22,
        "nonnacha_abi22": branding.nonnacha_abi22,
        "loc_primary_abi22": branding.loc_primary_abi22
    };

  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };
  const className = props.className?(" "+props.className):"";

  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,
      onACHConfirmationClose:()=>{
        BCMSStateManagerCRUD.init(state)
        .update([ "data", "submittedOneTimeACHPayment" ], undefined)
        .submit(setState);
        window.history.replaceState({}, document.title);
      },
      showACHConfirmation:(data)=>{
        BCMSStateManagerCRUD.init(state)
        .update([ "data", "submittedOneTimeACHPayment" ], data)
        .submit(setState);
      },

      onUpdatePendingSameDayACHBatchesWidgetData: (prop, val) => {
        BCMSStateManagerCRUD.init(state)
        .update([ "data", "pendingSameDayACHBatchesWidgetData", prop ], val)
        .submit(setState);
      },

      onUpdatePageData: (prop, val) => {
        BCMSStateManagerCRUD.init(state)
        .update([ "data", prop ], val)
        .submit(setState);
      }
  });

  return (
    <PageContainer className={"activity-ach-page"+className} state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </PageContainer>
  )
}

export const getDefaultData = () => ({
  pendingSameDayACHBatchesWidgetData: {
    showSearchOptions: false,
    achBatches: ACHBatch.initAll().filter(item => {
      return (item.status === "pending approval" && item.scheduleType === "same day") 
      || (item.status === "pending processing" && item.scheduleType === "same day") 
    })
    // Example of setting search values.
    //achSearch: ACHSearch.init({batch: "some batch 1", status: "rejected"})

  },
  pendingACHBatchesWidgetData: {
    showSearchOptions: false,
    achBatches: ACHBatch.initAll().filter(item => item.status === "pending approval" && item.scheduleType === "immediate")
    // Example of setting search values.
    //achSearch: ACHSearch.init({batch: "some batch 2", status: "approved"})
  },
  scheduledACHBatchesWidget: {
    showSearchOptions: false,
    achBatches: ACHBatch.initAll().filter(item => item.status === "pending approval" && item.scheduleType !== "same day")
    // Example of setting search values.
    //achSearch: ACHSearch.init({batch: "some batch 3", status: "approved", schedule: "some schedule"})
  },
  historyACHWidget: {
    showSearchOptions: false,
    viewLatestForRecurringBatches: true,
    achBatches: ACHBatch.initAll().filter(item => item.status === "canceled" )
    // Example of setting search values.
    //achSearch: ACHSearch.init({batch: "some batch 4", status: "approved"})
  },

  submittedOneTimeACHPayment: undefined,
  showSuccessBanner: { show: false },
  approvedACHBatch: { batch: undefined }
});

// no ui changes for now
export const getDefaultUI = () => ({
  pendingSameDayACHBatchesWidgetUI: {
    
  },
  pendingACHBatchesWidgetUI: {
    
  },
  scheduledACHBatchesWidgetUI: {
    
  },
  historyACHWidgetUI: {
    
  }
});

function PageContent(props) {
  const { data, ui, showACHConfirmation, onUpdatePageData, onUpdatePendingSameDayACHBatchesWidgetData } = useStateManager();
  const { route } = useRouteData();
  const {addedOneTimeACHPayment} = route ? route : {}; 

  let approvedACHBatch = data.approvedACHBatch.batch;

  let successBannerText = "";
  if(data.showSuccessBanner.show) {
    successBannerText = `The "One-Time" batch (Ref #${ approvedACHBatch.referenceNumber }) has been approved.`;
  }

  useEffect(()=>{
    if(addedOneTimeACHPayment!== undefined) {
      if(addedOneTimeACHPayment instanceof Object) {
        const achBatch = ACHBatch.initByID(addedOneTimeACHPayment.id);
        showACHConfirmation(achBatch)
      }
      
    }
  },[]);

  return (
  <PageContentView>
    <div className="flex-container flex-vertical flex-width">
       { data.showSuccessBanner.show && <SuccessBanner text={ successBannerText }/> }
       { data.submittedOneTimeACHPayment && <ACHBatchConfirmationWidget data={ data.submittedOneTimeACHPayment } /> }
        
        <PendingSameDayACHBatchesWidget 
        data={ data.pendingSameDayACHBatchesWidgetData } ui={ ui.pendingSameDayACHBatchesWidgetUI }
        onUpdatePendingSameDayACHBatchesWidgetData={ onUpdatePendingSameDayACHBatchesWidgetData } 
        onUpdatePageData={ onUpdatePageData }/>

        <PendingACHBatchesWidget data={ data.pendingACHBatchesWidgetData } ui={ ui.pendingACHBatchesWidgetUI } />
        <ScheduledACHBatchesWidget data={ data.scheduledACHBatchesWidget } ui={ ui.scheduledACHBatchesWidgetUI } />
        <HistoryACHWidget data={ data.historyACHWidget } ui={ ui.historyACHWidgetUI } />
    </div>
  </PageContentView>
  );
}

function SuccessBanner(props) {
  const text = props.text ?? "" ;
  const icon = <SVGAsset id="InfoIcon" className="set-width info-icon" />;
  return (
    <ConfirmBannerView text={text} icon={icon} onClick={props.onClick} dataPoint={ props.dataPoint } />
  );
}